import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../lib/AuthContext'
import LibreriaEsercizi from './LibreriaEsercizi'
import { useIndietro } from '../lib/navigazioneIndietro'
import { IMPOSTAZIONI_PREDEFINITE, comeLista, lavoroDelBlocco, secondiEsercizio, origineSecondi, ripetizioniPreviste } from '../lib/formati'

const FORMATI = [
  { id: 'classico', nome: 'Classico', desc: 'Serie × Ripetizioni', icona: '🏋️', colore: 'var(--accent)' },
  { id: 'emom', nome: 'EMOM', desc: 'Every Minute On the Minute', icona: '⚡', colore: 'var(--green)' },
  { id: 'amrap', nome: 'AMRAP', desc: 'Max rip. in X minuti', icona: '♾️', colore: 'var(--accent2)' },
  { id: 'tabata', nome: 'Tabata', desc: '20s lavoro / 10s pausa × 8', icona: '🔥', colore: 'var(--accent3)' },
  { id: 'circuit', nome: 'Circuit', desc: 'N giri con pausa tra giri', icona: '🔄', colore: 'var(--purple)' },
  { id: 'a_tempo', nome: 'A tempo', desc: 'X sec lavoro / Y sec pausa', icona: '⏱️', colore: '#ffd93d' },
]

/**
 * Allinea i secondi degli esercizi a tempo a quelli che il blocco esegue davvero.
 *
 * Prima si potevano salvare due numeri per la stessa cosa: un blocco "A tempo"
 * da 40s di lavoro con dentro un Plank impostato a 30s. Il cronometro eseguiva
 * i 40 del blocco, i 30 non li leggeva nessuno, ma il riepilogo del coach
 * scriveva "30s". Qui il numero morto viene riscritto con quello vero, così nel
 * database resta un solo valore e tutte le schermate mostrano lo stesso.
 */
function allineaDurate(blocco) {
  const dalBlocco = lavoroDelBlocco(blocco)
  if (dalBlocco == null) return blocco
  return {
    ...blocco,
    esercizi: (blocco.esercizi || []).map(e => (
      e.tipo_misura === 'tempo' && e.durata !== dalBlocco ? { ...e, durata: dalBlocco } : e
    )),
  }
}

function BloccoCard({ blocco, idx, totale, onEdit, onDelete, onSposta }) {
  const fmt = FORMATI.find(f => f.id === blocco.formato) || FORMATI[0]
  const vuoto = (blocco.esercizi || []).length === 0
  return (
    <div style={{ border: `1px solid ${vuoto ? 'rgba(255,120,87,0.4)' : 'var(--border)'}`, borderRadius: 12, overflow: 'hidden' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', background: 'var(--surface2)', borderBottom: '1px solid var(--border)' }}>
        <span style={{ fontSize: 18 }}>{fmt.icona}</span>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 700, fontSize: 13 }}>{blocco.nome || `Blocco ${idx + 1}`}</div>
          <div style={{ fontSize: 11, color: 'var(--muted)' }}>{fmt.nome} · {blocco.esercizi?.length || 0} esercizi</div>
        </div>
        <div style={{ display: 'flex', gap: 4 }}>
          {idx > 0 && <button onClick={() => onSposta(idx, -1)} style={{ background: 'none', border: '1px solid var(--border)', borderRadius: 6, padding: '2px 7px', color: 'var(--muted)', cursor: 'pointer', fontSize: 12 }}>↑</button>}
          {idx < totale - 1 && <button onClick={() => onSposta(idx, 1)} style={{ background: 'none', border: '1px solid var(--border)', borderRadius: 6, padding: '2px 7px', color: 'var(--muted)', cursor: 'pointer', fontSize: 12 }}>↓</button>}
          <button onClick={() => onEdit(idx)} style={{ background: 'none', border: '1px solid var(--border)', borderRadius: 6, padding: '2px 7px', color: 'var(--accent)', cursor: 'pointer', fontSize: 11 }}>✏️</button>
          <button onClick={() => onDelete(idx)} style={{ background: 'none', border: '1px solid rgba(248,113,113,0.3)', borderRadius: 6, padding: '2px 7px', color: 'var(--red)', cursor: 'pointer', fontSize: 11 }}>✕</button>
        </div>
      </div>

      {/* Un blocco senza esercizi si vede PRIMA di premere Salva, invece di
          scoprirlo da un messaggio d'errore quando la sessione è già scritta. */}
      {vuoto ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '9px 14px', background: 'rgba(255,120,87,0.08)' }}>
          <span style={{ fontSize: 13, flexShrink: 0 }}>⚠️</span>
          <span style={{ fontSize: 11, color: 'var(--accent3)', lineHeight: 1.4, flex: 1 }}>
            Nessun esercizio: l'atleta non avrebbe niente da fare in questo blocco
          </span>
          <button onClick={() => onEdit(idx)} style={{ background: 'none', border: 'none', color: 'var(--accent3)', cursor: 'pointer', fontSize: 11, fontWeight: 700, fontFamily: 'Syne', whiteSpace: 'nowrap' }}>Aggiungi ›</button>
        </div>
      ) : (
        <div style={{ padding: '8px 14px' }}>
          {(blocco.esercizi || []).map((e, i) => (
            <div key={i} style={{ fontSize: 12, color: 'var(--muted)', padding: '3px 0', borderBottom: i < blocco.esercizi.length - 1 ? '1px solid rgba(255,255,255,0.04)' : 'none', display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ color: 'var(--text)' }}>{e.nome}</span>
              {/* secondiEsercizio e non e.durata: nelle sessioni salvate prima di questa
                  correzione il campo durata può contenere ancora il numero morto.
                  Il "quante volte" viene dal blocco quando è il blocco a deciderlo. */}
              <span>{(() => {
                const volte = ripetizioniPreviste(blocco, e)
                const quanto = e.tipo_misura === 'tempo' ? `${secondiEsercizio(blocco, e)}s` : `${e.ripetizioni || '?'} rip`
                return `${volte > 1 ? `${volte}× ` : ''}${quanto}`
              })()}{e.peso > 0 ? ` @${e.peso}kg` : ''}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

function EditBlocco({ blocco, onSalva, onAnnulla }) {
  const { profilo } = useAuth()
  const [b, setB] = useState(blocco)
  const [avviso, setAvviso] = useState('')   // toast_msg vive nel componente padre e qui non è accessibile
  const [scegliEx, setScegliEx] = useState(false)
  const [preferiti, setPreferiti] = useState([]) // esercizi preferiti del coach, per l'aggiunta rapida senza aprire la libreria

  // Tasto indietro sulla libreria del blocco: la chiude e basta, come la sua freccia.
  // Senza questa registrazione l'indietro chiudeva l'intera sessione non salvata.
  useIndietro(scegliEx, () => setScegliEx(false))

  const setField = (k, v) => setB(p => ({ ...p, [k]: v }))
  const setImp = (k, v) => setB(p => ({ ...p, impostazioni: { ...(p.impostazioni || {}), [k]: v } }))

  // Carica i preferiti del coach (stessa tabella esercizi_preferiti usata dalla libreria)
  useEffect(() => {
    async function caricaPreferiti() {
      const { data } = await supabase.from('esercizi_preferiti')
        .select('esercizio_id, esercizi_db(id, nome, tipo_misura, attrezzatura, consente_elastico, varianti, regressioni)')
        .eq('utente_id', profilo.id)
      setPreferiti((data || []).map(p => p.esercizi_db).filter(Boolean))
    }
    caricaPreferiti()
  }, [profilo.id])

  // Ricarica varianti aggiornate dal DB per ogni esercizio del blocco
  useEffect(() => {
    async function aggiornVarianti() {
      const { supabase } = await import('../lib/supabase')
      const esIds = (blocco.esercizi || []).map(e => e.esercizioId).filter(Boolean)
      if (esIds.length === 0) return
      const { data } = await supabase.from('esercizi_db').select('id, varianti, regressioni').in('id', esIds)
      if (!data) return
      setB(p => ({
        ...p,
        esercizi: (p.esercizi || []).map(ex => {
          const aggiornato = data.find(d => d.id === ex.esercizioId)
          if (!aggiornato) return ex
          const varianti = [...(aggiornato.varianti || []), ...(aggiornato.regressioni || [])]
          return { ...ex, varianti }
        })
      }))
    }
    aggiornVarianti()
  }, [])

  function aggiungiEx(ex) {
    const varianti = [...comeLista(ex.varianti), ...comeLista(ex.regressioni)]
    setB(p => ({
      ...p,
      esercizi: [...(p.esercizi || []), {
        esercizioId: ex.id, nome: ex.nome,
        varianteId: ex.varianti?.[0]?.id || null,
        varianteNome: ex.varianti?.[0]?.nome || 'Standard',
        tipo_misura: ex.tipo_misura,
        attrezzatura: ex.attrezzatura || [],
        consenteElastico: !!ex.consente_elastico,
        // Valori iniziali coerenti col tipo: a un esercizio a tempo non servono serie e
        // ripetizioni, che restavano lì come valori morti e comparivano all'atleta come "3×10".
        // Se il formato del blocco impone già i secondi, l'esercizio nasce con quelli.
        // Nel Classico anche un esercizio a tempo ha un numero di serie: nasce a 3
        // come gli altri, così il tetto per l'atleta c'è fin da subito. Negli
        // altri formati le volte le dice il blocco, e qui resta vuoto.
        ...(ex.tipo_misura === 'tempo'
          ? { serie: p.formato === 'classico' ? 3 : null, ripetizioni: null, durata: lavoroDelBlocco(p) ?? 30 }
          : { serie: 3, ripetizioni: 10, durata: null }),
        peso: 0, note: '',
        varianti: varianti,
      }]
    }))
    setScegliEx(false)
  }

  function rimuoviEx(i) { setB(p => ({ ...p, esercizi: p.esercizi.filter((_, j) => j !== i) })) }
  function aggEx(i, k, v) { setB(p => ({ ...p, esercizi: p.esercizi.map((e, j) => j === i ? { ...e, [k]: v } : e) })) }

  if (scegliEx) return <LibreriaEsercizi modalitaScelta={true} onScelto={aggiungiEx} onChiudi={() => setScegliEx(false)} />

  const fmt = FORMATI.find(f => f.id === b.formato) || FORMATI[0]
  // Se il formato detta già il tempo di lavoro, l'esercizio non ha un suo numero da
  // digitare: il campo SECONDI diventa l'informazione di cosa eseguirà l'atleta.
  const secondiImposti = lavoroDelBlocco(b)

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }} className="fade-in">
      <div className="topbar">
        <button className="back-btn" onClick={onAnnulla}>←</button>
        <div style={{ fontFamily: 'Syne', fontWeight: 700 }}>Configura blocco</div>
        {/* Un blocco vuoto veniva accettato: gli atleti si ritrovavano una sessione
            assegnata senza niente da fare */}
        <button className="btn btn-primary btn-sm" onClick={() => {
          if ((b.esercizi || []).length === 0) { setAvviso('Aggiungi almeno un esercizio al blocco'); setTimeout(() => setAvviso(''), 2500); return }
          onSalva(allineaDurate(b))
        }}>Salva</button>
      </div>
      {avviso && <div className="toast">{avviso}</div>}
      <div className="scroll-area">
        <div className="form-group">
          <label className="form-label">Nome blocco</label>
          <input className="form-input" value={b.nome || ''} onChange={e => setField('nome', e.target.value)} placeholder="es. Riscaldamento, EMOM forza..." />
        </div>

        <div className="form-group">
          <label className="form-label">Formato</label>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            {FORMATI.map(f => (
              <button key={f.id} type="button" onClick={() => setB(p => ({
                ...p, formato: f.id,
                // I valori predefiniti vanno SCRITTI nel blocco, non solo mostrati nei campi:
                // se il coach non li toccava, il blocco veniva salvato senza e l'atleta
                // leggeva "30s/undefineds". Quelli già impostati non vengono sovrascritti.
                impostazioni: { ...IMPOSTAZIONI_PREDEFINITE[f.id], ...(p.impostazioni || {}) },
              }))} style={{ padding: '10px', borderRadius: 10, border: `2px solid ${b.formato === f.id ? f.colore : 'var(--border)'}`, background: b.formato === f.id ? `rgba(255,255,255,0.05)` : 'var(--surface2)', cursor: 'pointer', textAlign: 'left', transition: 'all 0.2s' }}>
                <div style={{ fontSize: 16, marginBottom: 2 }}>{f.icona}</div>
                <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 12, color: b.formato === f.id ? f.colore : 'var(--text)' }}>{f.nome}</div>
                <div style={{ fontSize: 10, color: 'var(--muted)', marginTop: 1 }}>{f.desc}</div>
              </button>
            ))}
          </div>
        </div>

        {/* Impostazioni formato */}
        <div className="card">
          <div className="card-header"><div className="card-title">{fmt.icona} Impostazioni {fmt.nome}</div></div>
          <div className="card-body" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            {(b.formato === 'emom' || b.formato === 'amrap') && (
              <div style={{ gridColumn: '1/-1' }}>
                <input className="num-input" type="number" value={b.impostazioni?.durata || 10} onChange={e => setImp('durata', +e.target.value)} />
                <div style={{ fontSize: 10, color: 'var(--muted)', textAlign: 'center', marginTop: 3 }}>MINUTI TOTALI</div>
              </div>
            )}
            {b.formato === 'classico' && (
              <div style={{ gridColumn: '1/-1' }}>
                <input className="num-input" type="number" value={b.impostazioni?.riposo || 90} onChange={e => setImp('riposo', +e.target.value)} />
                <div style={{ fontSize: 10, color: 'var(--muted)', textAlign: 'center', marginTop: 3 }}>SEC RIPOSO TRA SERIE</div>
              </div>
            )}
            {b.formato === 'a_tempo' && (<>
              <div><input className="num-input" type="number" value={b.impostazioni?.lavoro || 40} onChange={e => setImp('lavoro', +e.target.value)} /><div style={{ fontSize: 10, color: 'var(--muted)', textAlign: 'center', marginTop: 3 }}>SEC LAVORO</div></div>
              <div><input className="num-input" type="number" value={b.impostazioni?.pausa || 20} onChange={e => setImp('pausa', +e.target.value)} /><div style={{ fontSize: 10, color: 'var(--muted)', textAlign: 'center', marginTop: 3 }}>SEC PAUSA</div></div>
              {/* GIRI mancava: senza, il blocco passava una volta sola sugli esercizi
                  e un Plank da 40s era tutto il blocco. */}
              <div style={{ gridColumn: '1/-1' }}>
                <input className="num-input" type="number" min="1" value={b.impostazioni?.giri || 1} onChange={e => setImp('giri', Math.max(1, +e.target.value || 1))} />
                <div style={{ fontSize: 10, color: 'var(--muted)', textAlign: 'center', marginTop: 3 }}>GIRI — QUANTE VOLTE SI RIPETE IL BLOCCO</div>
              </div>
            </>)}
            {b.formato === 'circuit' && (<>
              {/* SEC LAVORO mancava del tutto: il cronometro eseguiva 40 secondi fissi
                  e il coach non aveva modo di cambiarli da nessuna parte. */}
              <div><input className="num-input" type="number" value={b.impostazioni?.lavoro || 40} onChange={e => setImp('lavoro', +e.target.value)} /><div style={{ fontSize: 10, color: 'var(--muted)', textAlign: 'center', marginTop: 3 }}>SEC LAVORO</div></div>
              <div><input className="num-input" type="number" value={b.impostazioni?.giri || 3} onChange={e => setImp('giri', +e.target.value)} /><div style={{ fontSize: 10, color: 'var(--muted)', textAlign: 'center', marginTop: 3 }}>GIRI</div></div>
              <div style={{ gridColumn: '1/-1' }}><input className="num-input" type="number" value={b.impostazioni?.pausa || 60} onChange={e => setImp('pausa', +e.target.value)} /><div style={{ fontSize: 10, color: 'var(--muted)', textAlign: 'center', marginTop: 3 }}>SEC PAUSA TRA GIRI</div></div>
            </>)}
            {b.formato === 'tabata' && (
              <div className="alert alert-info" style={{ gridColumn: '1/-1', fontSize: 12 }}>
                <span>⚡</span><span>8 round × 20s lavoro / 10s pausa per esercizio. ~4 min per esercizio.</span>
              </div>
            )}
          </div>
        </div>

        {/* Preferiti del coach: aggiunta rapida senza aprire la libreria intera */}
        {preferiti.length > 0 && (
          <div className="card">
            <div className="card-header">
              <div className="card-title">⭐ I tuoi preferiti</div>
              <span style={{ fontSize: 12, color: 'var(--muted)' }}>Tocca per aggiungere</span>
            </div>
            <div style={{ padding: '8px 12px', display: 'flex', flexDirection: 'column', gap: 4 }}>
              {preferiti.map(ex => (
                <div key={ex.id} onClick={() => aggiungiEx(ex)}
                  style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 12,
                    background: 'var(--surface2)', border: '1px solid var(--border)', cursor: 'pointer' }}>
                  <span style={{ fontSize: 15, color: 'var(--accent)' }}>★</span>
                  <div style={{ flex: 1, fontWeight: 600, fontSize: 13 }}>{ex.nome}</div>
                  <span style={{ color: 'var(--accent)', fontSize: 16 }}>+</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Esercizi del blocco — quando la lista è vuota il pulsante sta solo dentro
            lo stato vuoto: prima erano due pulsanti identici a pochi centimetri */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ fontFamily: 'Syne', fontWeight: 700 }}>Esercizi del blocco</div>
          {(b.esercizi || []).length > 0 && (
            <button className="btn btn-primary btn-sm" onClick={() => setScegliEx(true)}>+ Aggiungi</button>
          )}
        </div>

        {(b.esercizi || []).length === 0 ? (
          <div className="card"><div className="card-body" style={{ textAlign: 'center', padding: '20px' }}>
            <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 12 }}>Nessun esercizio ancora</div>
            <button className="btn btn-primary" onClick={() => setScegliEx(true)}>📚 Sfoglia libreria</button>
          </div></div>
        ) : (
          <div className="card">
            <div style={{ padding: '0 16px' }}>
              {(b.esercizi || []).map((e, idx) => {
                // Quante volte l'atleta esegue QUESTO esercizio: nei formati a
                // struttura lo dicono i giri del blocco, non un campo dell'esercizio.
                const volteDelBlocco = ripetizioniPreviste(b, e)
                return (
                <div key={idx} style={{ padding: '12px 0', borderBottom: idx < b.esercizi.length - 1 ? '1px solid var(--border)' : 'none' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                    <div style={{ fontWeight: 600, fontSize: 13 }}>{idx + 1}. {e.nome}</div>
                    <button onClick={() => rimuoviEx(idx)} style={{ background: 'none', border: 'none', color: 'var(--red)', cursor: 'pointer', fontSize: 16 }}>✕</button>
                  </div>

                  {e.varianti?.length > 0 && (
                    <div className="form-group" style={{ marginBottom: 8 }}>
                      <label className="form-label">Variante / Regressione</label>
                      <select className="form-select" style={{ fontSize: 12, padding: '8px 12px' }} value={e.varianteId || ''} onChange={ev => {
                        const v = e.varianti.find(x => x.id === ev.target.value)
                        aggEx(idx, 'varianteId', ev.target.value)
                        aggEx(idx, 'varianteNome', v?.nome || '')
                      }}>
                        {e.varianti.map(v => <option key={v.id} value={v.id}>{v.nome}</option>)}
                      </select>
                    </div>
                  )}

                  <div style={{ display: 'grid', gridTemplateColumns: e.tipo_misura === 'tempo'
                    ? (b.formato === 'classico' ? '1fr 1fr' : '1fr')
                    : (b.formato === 'classico' ? '1fr 1fr 1fr' : '1fr 1fr'), gap: 8 }}>
                    {e.tipo_misura === 'tempo' ? (<>
                      {/* SERIE mancava per gli esercizi a tempo: nel Classico un
                          Plank non aveva un numero di serie previsto, quindi
                          all'atleta non scattava nessun tetto e poteva
                          registrarne all'infinito. */}
                      {b.formato === 'classico' && (
                        <div>
                          <input className="num-input" type="number" min="1" value={e.serie ?? ''}
                            onChange={ev => aggEx(idx, 'serie', ev.target.value === '' ? null : +ev.target.value)} />
                          <div style={{ fontSize: 9, color: 'var(--muted)', textAlign: 'center', marginTop: 3 }}>SERIE</div>
                        </div>
                      )}
                      {secondiImposti != null ? (
                        /* Nessun campo da digitare: in questo formato i secondi li decide
                           il blocco, e un numero diverso scritto qui non verrebbe mai
                           eseguito. Si mostra quello vero, con il perché. */
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px', borderRadius: 10, background: 'rgba(255,255,255,0.04)', border: '1px solid var(--border)' }}>
                          <span style={{ fontFamily: '"Instrument Sans", sans-serif', fontWeight: 600, fontSize: 26, lineHeight: 1, color: fmt.colore, fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>
                            {volteDelBlocco > 1 ? `${volteDelBlocco} × ` : ''}{secondiImposti}s
                          </span>
                          <span style={{ fontSize: 11, color: 'var(--muted)', lineHeight: 1.45 }}>
                            {/* La domanda vera del coach è "quante volte si fa", non
                                "quanto dura": la risposta sta prima della provenienza. */}
                            {volteDelBlocco > 1
                              ? `${volteDelBlocco} volte da ${secondiImposti}s${b.impostazioni?.pausa ? `, ${b.impostazioni.pausa}s di pausa fra una e l'altra` : ''}`
                              : `una volta sola da ${secondiImposti}s`}
                            <br />{origineSecondi(b.formato)}
                          </span>
                        </div>
                      ) : (
                        <div><input className="num-input" type="number" value={e.durata} onChange={ev => aggEx(idx, 'durata', +ev.target.value)} /><div style={{ fontSize: 9, color: 'var(--muted)', textAlign: 'center', marginTop: 3 }}>SECONDI</div></div>
                      )}
                    </>) : (<>
                      {b.formato === 'classico' && (
                        <div><input className="num-input" type="number" value={e.serie} onChange={ev => aggEx(idx, 'serie', +ev.target.value)} /><div style={{ fontSize: 9, color: 'var(--muted)', textAlign: 'center', marginTop: 3 }}>SERIE</div></div>
                      )}
                      <div><input className="num-input" type="number" value={e.ripetizioni} onChange={ev => aggEx(idx, 'ripetizioni', +ev.target.value)} /><div style={{ fontSize: 9, color: 'var(--muted)', textAlign: 'center', marginTop: 3 }}>{b.formato === 'amrap' ? 'RIP TARGET' : 'RIPETIZIONI'}</div></div>
                      <div><input className="num-input" type="number" value={e.peso || 0} onChange={ev => aggEx(idx, 'peso', +ev.target.value)} /><div style={{ fontSize: 9, color: 'var(--muted)', textAlign: 'center', marginTop: 3 }}>KG</div></div>
                    </>)}
                  </div>
                  <input className="form-input" placeholder="Note tecniche..." value={e.note || ''} onChange={ev => aggEx(idx, 'note', ev.target.value)} style={{ marginTop: 8, fontSize: 12, padding: '8px 12px' }} />
                </div>
                )
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default function CreaSessione({ programmaId, gruppoId, onSalvato, onAnnulla, sessioneEsistente }) {
  const { profilo } = useAuth()
  const [nome, setNome] = useState(sessioneEsistente?.nome || '')
  const [descrizione, setDescrizione] = useState(sessioneEsistente?.descrizione || '')
  const [durata, setDurata] = useState(sessioneEsistente?.durata_minuti || 60)
  const [blocchi, setBlocchi] = useState(sessioneEsistente?.blocchi || [])
  const [editIdx, setEditIdx] = useState(null)
  // Blocco in CREAZIONE, tenuto da parte e non ancora nella lista.
  //
  // Prima "+ Blocco" lo aggiungeva subito a blocchi[] e poi apriva l'editor:
  // chi tornava indietro si lasciava alle spalle un blocco vuoto nella
  // sessione, e il salvataggio lo accettava — l'atleta si ritrovava una
  // sessione con un blocco senza niente dentro. Ora il blocco entra nella
  // lista solo quando il coach preme Salva nell'editor.
  const [bloccoNuovo, setBloccoNuovo] = useState(null)
  // Tasto indietro sull'editor del blocco: torna alla sessione (= onAnnulla del blocco)
  useIndietro(editIdx !== null, () => setEditIdx(null))
  useIndietro(bloccoNuovo !== null, () => setBloccoNuovo(null))
  const [salvataggio, setSalvataggio] = useState(false)
  const [toast, setToast] = useState('')

  function toast_msg(msg) { setToast(msg); setTimeout(() => setToast(''), 2500) }

  function aggiungiBlocco() {
    setBloccoNuovo({ nome: '', formato: 'classico', impostazioni: { ...IMPOSTAZIONI_PREDEFINITE.classico }, esercizi: [] })
  }

  function salvaBlocco(idx, bNuovo) { setBlocchi(p => p.map((b, i) => i === idx ? bNuovo : b)); setEditIdx(null) }
  function eliminaBlocco(idx) { setBlocchi(p => p.filter((_, i) => i !== idx)) }
  function spostaBlocco(idx, dir) {
    setBlocchi(p => {
      const arr = [...p]
      const t = idx + dir
      if (t < 0 || t >= arr.length) return arr
      ;[arr[idx], arr[t]] = [arr[t], arr[idx]]
      return arr
    })
  }

  async function salva() {
    if (!nome.trim()) { toast_msg('Dai un nome alla sessione'); return }
    if (blocchi.length === 0) { toast_msg('Aggiungi almeno un blocco'); return }
    // Un blocco senza esercizi non va nel database: l'editor del blocco lo
    // impedisce già, ma una sessione creata prima di questa correzione può
    // averne uno, e riaprirla in modifica non obbliga a passare dall'editor.
    const idxVuoto = blocchi.findIndex(b => (b.esercizi || []).length === 0)
    if (idxVuoto >= 0) {
      const b = blocchi[idxVuoto]
      toast_msg(`"${b.nome || `Blocco ${idxVuoto + 1}`}" non ha esercizi: aggiungine uno o elimina il blocco`)
      return
    }
    setSalvataggio(true)
    // Ultima rete: anche i blocchi delle sessioni create prima di questa correzione,
    // riaperti in modifica senza passare dall'editor del blocco, finiscono allineati.
    const daSalvare = blocchi.map(allineaDurate)
    let error
    if (sessioneEsistente?.id) {
      // Modifica sessione esistente
      const res = await supabase.from('sessioni_tipo').update({
        nome, descrizione, durata_minuti: durata, blocchi: daSalvare,
      }).eq('id', sessioneEsistente.id)
      error = res.error
    } else {
      // Nuova sessione
      const res = await supabase.from('sessioni_tipo').insert({
        programma_id: programmaId || null,
        gestore_id: profilo.id,
        gruppo_id: gruppoId || null,
        nome, descrizione, durata_minuti: durata,
        blocchi: daSalvare,
      })
      error = res.error
    }
    setSalvataggio(false)
    if (error) { toast_msg('Errore: ' + error.message); return }
    toast_msg(sessioneEsistente?.id ? '✅ Sessione aggiornata!' : '✅ Sessione salvata!')
    setTimeout(() => onSalvato && onSalvato(), 1200)
  }

  // Creazione di un blocco nuovo: va controllata PRIMA della modifica, ed entra
  // nella lista solo premendo Salva. Annullando non resta traccia.
  if (bloccoNuovo) return (
    <EditBlocco
      blocco={bloccoNuovo}
      onSalva={b => { setBlocchi(p => [...p, b]); setBloccoNuovo(null) }}
      onAnnulla={() => setBloccoNuovo(null)}
    />
  )

  if (editIdx !== null) return (
    <EditBlocco
      blocco={blocchi[editIdx] || { nome: '', formato: 'classico', impostazioni: {}, esercizi: [] }}
      onSalva={b => salvaBlocco(editIdx, b)}
      onAnnulla={() => setEditIdx(null)}
    />
  )

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }} className="fade-in">
      <div className="topbar">
        <button className="back-btn" onClick={onAnnulla}>←</button>
        <div style={{ fontFamily: 'Syne', fontWeight: 700 }}>{sessioneEsistente?.id ? 'Modifica sessione' : 'Crea sessione'}</div>
        <button className="btn btn-primary btn-sm" onClick={salva} disabled={salvataggio}>
          {salvataggio ? '⏳' : '✓ Salva'}
        </button>
      </div>

      <div className="scroll-area">
        <div className="form-group">
          <label className="form-label">Nome sessione *</label>
          <input className="form-input" value={nome} onChange={e => setNome(e.target.value)} placeholder="es. Lunedì Upper Body, EMOM Forza..." style={{ fontSize: 17 }} autoFocus />
        </div>
        <div className="form-group">
          <label className="form-label">Descrizione (opzionale)</label>
          <input className="form-input" value={descrizione} onChange={e => setDescrizione(e.target.value)} placeholder="Note per gli atleti..." />
        </div>
        <div className="form-group">
          <label className="form-label">Durata prevista (minuti)</label>
          <input className="num-input" type="number" value={durata} onChange={e => setDurata(+e.target.value)} />
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontFamily: 'Syne', fontWeight: 700 }}>Blocchi della sessione</div>
            <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>Ogni blocco ha il suo formato e i suoi esercizi</div>
          </div>
          <button className="btn btn-primary btn-sm" onClick={aggiungiBlocco}>+ Blocco</button>
        </div>

        {blocchi.length === 0 ? (
          <div className="card">
            <div className="card-body" style={{ textAlign: 'center', padding: '30px 16px' }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>🏗️</div>
              <div style={{ fontFamily: 'Syne', fontWeight: 700, marginBottom: 8 }}>Nessun blocco ancora</div>
              <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 16, lineHeight: 1.6 }}>
                Aggiungi blocchi per costruire la sessione.<br />
                Ogni blocco può avere un formato diverso —<br />
                EMOM, Tabata, Classico, AMRAP...
              </div>
              <button className="btn btn-primary" onClick={aggiungiBlocco}>+ Aggiungi primo blocco</button>
            </div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {blocchi.map((b, idx) => (
              <BloccoCard key={idx} blocco={b} idx={idx} totale={blocchi.length}
                onEdit={setEditIdx} onDelete={eliminaBlocco} onSposta={spostaBlocco} />
            ))}
            <button className="btn btn-ghost" onClick={aggiungiBlocco}>+ Aggiungi blocco</button>
          </div>
        )}

        {blocchi.length > 0 && (
          <div className="card">
            <div className="card-body" style={{ fontSize: 12, color: 'var(--muted)' }}>
              <div style={{ fontFamily: 'Syne', fontWeight: 700, color: 'var(--text)', marginBottom: 8 }}>📋 Riepilogo sessione</div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                <span>Blocchi totali</span><span style={{ color: 'var(--text)' }}>{blocchi.length}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                <span>Esercizi totali</span><span style={{ color: 'var(--text)' }}>{blocchi.reduce((acc, b) => acc + (b.esercizi?.length || 0), 0)}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Durata prevista</span><span style={{ color: 'var(--text)' }}>{durata} min</span>
              </div>
            </div>
          </div>
        )}
      </div>
      {toast && <div className="toast">{toast}</div>}
    </div>
  )
}
